import RevokeGreenroomInvitation from '@/connection/greenroom/revoke-greenroom-invitation';
import { serializeError } from '@/store/utils/serialize-error';
import toastTrigger from '@ui/toast/toast-trigger';
import { ProjectStateReducerCreator } from '../types';

const revokeGreenroomInvitationReducer = (create: ProjectStateReducerCreator) => {
  return create.asyncThunk(
    async (
      payload: {
        sessionUuid: string;
        meeting: number;
        email: string;
        channel: number;
      },
      { rejectWithValue }
    ) => {
      try {
        await RevokeGreenroomInvitation(payload);
        return payload;
      } catch (error) {
        console.error(error);
        return rejectWithValue(serializeError(error));
      }
    },
    {
      fulfilled: (state, action) => {
        const sessionUuid = action.payload.sessionUuid;
        const email = action.payload.email;
        if (state.greenroomSessionMeetings?.[sessionUuid].invites) {
          state.greenroomSessionMeetings[sessionUuid].invites = state.greenroomSessionMeetings[
            sessionUuid
          ].invites.filter((invitee) => {
            return invitee.profile?.email !== email;
          });
        }
      },
      rejected: (state, action) => {
        const email = action.meta?.arg?.email;
        toastTrigger(
          `
          <div>
            <h4 class="H4">There was an error revoking presenter status for ${email}.</h4>
            <p class="S1">Please refresh and try again.</p>
            <p class="S1">If the error persists, please directly remove from within Greenroom®.</p>
          </div>
        `,
          {
            type: 'error',
            autoClose: false,
          }
        );
      },
    }
  );
};

export default revokeGreenroomInvitationReducer;
